const events = {
  analytics: {
    pageview: 'analytics:pageview',
  },
  download_btn: {
    initial_click: 'download_btn:initial_click',
    match_eezycore_free_dupe: 'download_btn:match_eezycore_free_dupe',
  },
  editor: {
    command: 'commandexec',
    exit: 'editor:exit',
    load: 'editor:load',
  },
  errors: {
    error404_page: 'errors:error404_page',
  },
  locale_prompt: {
    locale_prompt_accepted: 'locale_prompt:locale_prompt_accepted',
    locale_prompt_connects: 'locale_prompt:locale_prompt_connects',
    locale_prompt_dismissed: 'locale_prompt:locale_prompt_dismissed',
    switch_language: 'locale_prompt:switch_language',
  },
  generic: {
    track_generic_event: 'generic:track_event',
  },
  promos: {
    promo_popup: {
      cta_click: 'promos:promo_popup:cta_click',
      dismissed: 'promos:promo_popup:dismissed',
      popped: 'promos:promo_popup:popped',
    },
  },
  search: {
    apply_filters: 'search:apply_filters',
    click: 'search:click',
    filter: 'search:filter',
    search_type: 'search:search_type',
    without_results: 'search:without_results',
    trending_search_click: 'search:trending_search_click',
  },
  sessions: {
    new_account_created: 'sessions:new_account_created',
  },
  show_page: {
    download_ad_modal: 'show_page:download_ad_modal',
    license_selector_free_modal_connects: 'show_page:license_selector_free_modal_connects',
    license_selector_free_modal_closes: 'show_page:license_selector_free_modal_closes',
    license_selector_free_modal_free_button: 'show_page:license_selector_free_modal_free_button',
    license_selector_free_modal_pro_button: 'show_page:license_selector_free_modal_pro_button',
    attribution_link_copied: 'show_page:attribution_link_copied',
    license_selector_free_modal_learn_more: 'show_page:license_selector_free_modal_learn_more',
    download_limit_modal_connects: 'show_page:download_limit_modal_connects',
    download_ad_modal_connects: 'show_page:download_ad_modal_connects',
  },
  site_header: {
    header_join_pro: 'site_header:header_join_pro',
    header_login: 'site_header:header_login',
    header_signup: 'site_header:header_signup',
    related_tag_click: 'site_header:related_tag_click',
  },
  sponsored_search: {
    position: 'sponsored_search:position',
    without_results: 'sponsored_search:without_results',
  },
  checkout: {
    error: 'checkout:error',
  },
  sstk: {
    pagination_popup: 'sstk:pagination_popup',
    results_click: 'sstk:results_click',
    search_popup: 'sstk:search_popup',
  },
};

export default events;
